<template>
  <div class="wrapper-padding">
    <div class="my-2">
      <b-button
        id="choose-element"
        variant="primary"
        v-b-modal.select-module-modal
        :disabled="!notLoadedList"
        v-if="noChoice"
      >
        <div v-if="this.hasSelectedElements">
          <font-awesome-icon :icon="['fas', 'check']" /> Sélection effectuée
        </div>
        <div v-else>
          <font-awesome-icon :icon="['fas', 'plus']" /> Choisir les éléments à
          partager
        </div>
      </b-button>
    </div>
    <div class="my-2">
      <b-form-input
        v-model="email"
        type="email"
        placeholder="Email"
      ></b-form-input>
    </div>
    <div class="my-2">
      <b-form-input v-model="name" type="text" placeholder="Nom"></b-form-input>
    </div>
    <div class="my-2">
      <b-form-textarea
        v-model="message"
        type="textarea"
        placeholder="Message"
      ></b-form-textarea>
    </div>

    <b-button
      variant="primary"
      @click.prevent="handleClickSend"
      :disabled="btnDisable"
    >
      Envoyer
    </b-button>

    <div class="listing-box mt-2">
      <vue-custom-scrollbar class="scroll-area" :settings="settings">
        <listing-token
          :usersToken="usersTokenList"
          @openEditModal="openEditModal"
          @onDeleteInvitation="handleDeleteInvitation"
        ></listing-token>
      </vue-custom-scrollbar>
    </div>

    <!-- modal selection module a partager -->
    <b-modal
      id="select-module-modal"
      size="xl"
      title="Choisir les éléments à partager"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :modal-class="'base-modal'"
      ref="my-modal"
      @shown="initCheckboxes"
      @hidden="resetModal"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">Choisir les éléments à partager</h5>
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="cancelModalSelection"
        >
          ×
        </button>
      </template>

      <div class="listing-shared-element">
        <div>
          <div class="row">
            <div class="col-4">
              <div class="col-header table-col-header">TABLEAUX</div>
              <div class="checkbox-group">
                <div class="icon-example float-right">
                  <span class="border rounded icon-example-border">
                    <i class="bi bi-eye-fill"></i>
                  </span>
                  <span class="border rounded icon-example-border">
                    <i class="bi bi-pencil-fill"></i>
                  </span>
                </div>
                <div class="clearfix"></div>

                <vue-custom-scrollbar class="scroll-area" :settings="settings">
                  <div class="checkboxes-clickable">
                    <div class="table-name">
                      <div class="row m-0 pb-1">
                        <div class="col-9 pl-0"></div>
                        <div class="col-1 ml-0">
                          <input
                            type="checkbox"
                            id="check-all-view-table"
                            @click="
                              checkAllSimple(
                                'view',
                                'tableau',
                                $event.target.checked
                              )
                            "
                          />
                        </div>
                        <div class="col-1 ml-0">
                          <input
                            type="checkbox"
                            id="check-all-edit-table"
                            @click="
                              checkAllSimple(
                                'edit',
                                'tableau',
                                $event.target.checked
                              )
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row m-0 pb-1"
                      v-for="(element, index) in moduleData['tableau_surface']"
                      :key="element.id"
                    >
                      <div class="col-9 pl-0">
                        {{ element.name }}
                      </div>
                      <div class="col-1 ml-0">
                        <input
                          type="checkbox"
                          class="view-table"
                          v-model="tableauSurface"
                          :value="{ value: element.id, type: 'can-view' }"
                        />
                      </div>
                      <div class="col-1 ml-0">
                        <input
                          type="checkbox"
                          class="edit-table"
                          v-model="tableauSurface"
                          :value="{ value: element.id, type: 'can-edit' }"
                        />
                      </div>
                    </div>
                  </div>
                </vue-custom-scrollbar>
              </div>
            </div>
            <div class="col-4">
              <div class="col-header table-col-header">FICHES</div>
              <div class="checkbox-group">
                <div class="icon-example float-right">
                  <span class="border rounded icon-example-border">
                    <i class="bi bi-eye-fill"></i>
                  </span>
                  <span class="border rounded icon-example-border">
                    <i class="bi bi-pencil-fill"></i>
                  </span>
                </div>
                <div class="clearfix"></div>

                <!-- Scrollable area -->
                <vue-custom-scrollbar class="scroll-area" :settings="settings">
                  <div class="checkboxes-clickable">
                    <div
                      class="m-0 pb-1"
                      v-for="(element, index) in moduleData['tableau_surface']"
                      :key="element.id"
                    >
                      <div
                        v-if="
                          moduleData['fiche_espace'][element.id] &&
                          moduleData['fiche_espace'][element.id].length > 0
                        "
                      >
                        <div class="table-name">
                          <div class="row m-0 pb-1">
                            <div class="col-9 pl-0">
                              <h6 class="">{{ element.name }}</h6>
                            </div>
                            <div class="col-1 ml-0">
                              <input
                                type="checkbox"
                                :id="'viewAll_' + element.id"
                                name="check-all"
                                class="view_all"
                                v-model="isAllFicheViewChecked[element.id]"
                                @click="
                                  checkAll(
                                    element.id,
                                    'fiche_espace',
                                    'can-view',
                                    $event.target.checked
                                  )
                                "
                              />
                            </div>
                            <div class="col-1 ml-0">
                              <input
                                type="checkbox"
                                :id="'editAll_' + element.id"
                                name="check-all"
                                class="edit_all"
                                v-model="isAllFicheEditChecked[element.id]"
                                @click="
                                  checkAllEdit(
                                    element.id,
                                    'fiche_espace',
                                    'can-edit',
                                    $event.target.checked
                                  )
                                "
                                value="can-edit"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="clearfix"></div>

                        <div class="checkboxes-clickable">
                          <div
                            class="row m-0 pb-1"
                            v-for="(fiche, index) in moduleData['fiche_espace'][
                              element.id
                            ]"
                            :key="fiche.id"
                            v-if="fiche.fiche_name != ''"
                          >
                            <div class="col-9 pl-0" style="text-indent: 22px">
                              <span class="label-size">{{
                                fiche.fiche_name
                              }}</span>
                            </div>
                            <div class="col-1 ml-0">
                              <input
                                type="checkbox"
                                @click="
                                  updateCheckAll(
                                    element.id,
                                    $event.target.checked
                                  )
                                "
                                :class="'viewAll_' + element.id"
                                :value="{
                                  value: fiche.fiche_id,
                                  type: 'can-view',
                                }"
                                v-model="ficheEspacesModel[element.id]"
                              />
                              <!--                              <label :for="index" class="my-custom-label"></label>-->
                            </div>
                            <div class="col-1 ml-0">
                              <input
                                type="checkbox"
                                @click="
                                  updateCheckAllEdit(
                                    element.id,
                                    $event.target.checked
                                  )
                                "
                                :class="'editAll_' + element.id"
                                :value="{
                                  value: fiche.fiche_id,
                                  type: 'can-edit',
                                }"
                                v-model="ficheEspacesEditModel[element.id]"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-custom-scrollbar>
                <!-- END Scrollable area -->
              </div>
            </div>
            <div class="col-4">
              <div class="col-header table-col-header">SCHEMAS</div>
              <div class="checkbox-group">
                <div class="icon-example float-right">
                  <span class="border rounded icon-example-border">
                    <i class="bi bi-eye-fill"></i>
                  </span>
                  <span class="border rounded icon-example-border">
                    <i class="bi bi-pencil-fill"></i>
                  </span>
                </div>

                <div class="clearfix"></div>

                <vue-custom-scrollbar class="scroll-area" :settings="settings">
                  <div class="checkboxes-clickable">
                    <div class="table-name">
                      <div class="row m-0 pb-1">
                        <div class="col-9 pl-0"></div>
                        <div class="col-1 ml-0">
                          <input
                            type="checkbox"
                            id="check-all-view-schema"
                            @click="
                              checkAllSimple('view', '', $event.target.checked)
                            "
                          />
                        </div>
                        <div class="col-1 ml-0">
                          <input
                            type="checkbox"
                            id="check-all-edit-schema"
                            @click="
                              checkAllSimple('edit', '', $event.target.checked)
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row m-0 pb-1"
                      v-for="(element, index) in moduleData[
                        'schema_fonctionnel'
                      ]"
                      :key="element.id"
                    >
                      <div class="col-9 pl-0 text-center">
                        {{ element.name }}
                      </div>
                      <div class="col-1 ml-0">
                        <input
                          type="checkbox"
                          class="view-schema"
                          :value="{ value: element.id, type: 'can-view' }"
                          v-model="schema"
                        />
                      </div>
                      <div class="col-1 ml-0">
                        <input
                          type="checkbox"
                          class="edit-schema"
                          :value="{ value: element.id, type: 'can-edit' }"
                          v-model="schema"
                        />
                      </div>
                    </div>
                  </div>
                </vue-custom-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right pr-5">
          <span v-if="editId" style="padding-right: 15px">
            <input
              type="checkbox"
              name="notify-user"
              id="notify-user"
              v-model="notifyUser"
            />
            <label for="notify-user">
              <small
                ><strong
                  >Notifier l'invité par email des modifications</strong
                ></small
              >
            </label>
          </span>
          <button
            type="button"
            class="btn btn-secondary"
            @click="cancelModalSelection"
          >
            Annuler
          </button>
          <span v-if="editId == null">
            <button type="button" class="btn btn-primary" @click="saveChoices">
              OK
            </button>
          </span>
          <span v-else>
            <span
              v-if="
                !isEquivalent(initialTableau, tableauSurface) ||
                initialSchema.length != schema.length ||
                hasEdits
              "
            >
              <button
                v-if="!isLoading"
                type="button"
                class="btn btn-primary"
                @click="updateInvitation"
              >
                Editer
              </button>
              <b-button v-else class="txt-btn" variant="primary">
                <b-spinner small type="grow"></b-spinner> En attente...
              </b-button>
            </span>
            <span v-else>
              <button type="button" class="btn btn-primary" disabled>
                Editer
              </button>
            </span>
          </span>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import listingToken from './listingToken'
import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import { mapGetters } from 'vuex'
export default {
  props: {
    usersTokenList: {
      type: Array
    },
    entityId: {
      type: Number
    },
    typeModule: {
      type: String
    },
    listModuleInModal: {
      type: Object
    },
    btnDisable: {
      type: Boolean
    },
    notLoadedList: {
      type: Boolean
    }
  },
  components: {
    listingToken,
    vueCustomScrollbar
  },
  computed: {
    moduleData () {
      return this.listModuleInModal
    }
  },
  data () {
    return {
      notifyUser: false,
      editId: null,
      hasEdits: false,
      isAllFicheViewChecked: [],
      isAllFicheEditChecked: [],
      allFieldSelected: {},
      allFieldEditSelected: {},
      ficheEspaces: {},
      ficheEspacesModel: {},
      ficheEspacesEditModel: {},
      ficheEspacesEditable: {},
      finalFicheArray: {},
      tableauSurface: [],
      allTableauSelected: false,
      allTableauEditSelected: false,
      schema: [],
      selectedEntityId: [],
      name: null,
      email: null,
      message: null,
      noChoice: false,
      hasSelectedElements: false,
      choices: [],
      settings: {
        maxScrollbarLength: 60
      },
      initialTableau: [],
      initialFiche: [],
      initialFicheEdit: [],
      initialSchema: [],
      isLoading: false
    }
  },
  watch: {
    typeModule (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedEntityId = []
        this.checkNoChoice()
      }
    }
  },
  created () {
    this.$emit('onCreated')
    this.checkNoChoice()

    if (this.isProjectTemplate()) {
      this.noChoice = false
    }
  },
  methods: {
    ...mapGetters([
      'notifLink',
      'listOnglet',
      'listSchema',
      'currentProject',
      'setFiches',
      'isProjectTemplate'
    ]),
    isEquivalent (oldVal, newVal) {
      // var oldVal = old.sort((a, b) => (a.value > b.value) ? 1 : -1)
      // var newVal = newValue.sort((a, b) => (a.value > b.value) ? 1 : -1)

      // If number of properties is different,
      // objects are not equivalent
      if (oldVal.length !== newVal.length) {
        return false
      }

      for (var i in oldVal) {
        // If values of same property are not equal,
        // objects are not equivalent
        if (
          oldVal[i].value !== newVal[i].value ||
          oldVal[i].type !== newVal[i].type
        ) {
          return false
        }
      }

      // If we made it this far, objects
      // are considered equivalent
      return true
    },
    checkAllSimple: function (type, whichColumn, isChecked) {
      var el
      var theClass
      var theModel

      if (whichColumn === 'tableau') {
        theModel = this.tableauSurface

        if (type === 'view') {
          el = document.getElementById('check-all-view-table')
          theClass = '.view-table'
        } else {
          el = document.getElementById('check-all-edit-table')
          theClass = '.edit-table'
        }
      } else {
        theModel = this.schema

        if (type === 'view') {
          el = document.getElementById('check-all-view-schema')
          theClass = '.view-schema'
        } else {
          el = document.getElementById('check-all-edit-schema')
          theClass = '.edit-schema'
        }
      }

      el.onchange = function () {
        var checkboxes = document.querySelectorAll(theClass)

        for (var checkbox of checkboxes) {
          checkbox.checked = this.checked
          var valueObject = Object.values(checkbox)
          theModel.push(valueObject[1])
        }
      }

      if (isChecked) {
        this.hasEdits = true
      } else {
        this.hasEdits = false
      }
    },
    saveChoices () {
      var hasFiche = false

      for (var key in this.ficheEspacesModel) {
        for (var i = 0; i < this.ficheEspacesModel[key].length; i++) {
          if (this.ficheEspacesModel[key].length > 0) {
            hasFiche = true
          }
          this.finalFicheArray[key].push(this.ficheEspacesModel[key][i])
        }
      }

      for (var index in this.ficheEspacesEditModel) {
        for (var j = 0; j < this.ficheEspacesEditModel[index].length; j++) {
          if (this.ficheEspacesEditModel[index].length > 0) {
            hasFiche = true
          }
          this.finalFicheArray[index].push(
            this.ficheEspacesEditModel[index][j]
          )
        }
      }

      this.choices = {
        tableauSurface: this.tableauSurface,
        ficheEspaces: this.finalFicheArray,
        schema: this.schema
      }

      if (
        this.tableauSurface.length > 0 ||
        hasFiche ||
        this.schema.length > 0
      ) {
        this.hasSelectedElements = true

        if (document.getElementById('choose-element')) {
          document
            .getElementById('choose-element')
            .classList.add('selected-active')
        }
      } else {
        this.hasSelectedElements = false

        if (document.getElementById('choose-element')) {
          document
            .getElementById('choose-element')
            .classList.remove('selected-active')
        }
      }

      this.$refs['my-modal'].hide()
    },
    cancelModalSelection () {
      this.tableauSurface = []
      this.ficheEspaces = []
      this.ficheEspacesModel = []
      this.ficheEspacesEditModel = []
      this.schema = []

      this.hasSelectedElements = false

      if (document.getElementById('choose-element')) {
        document
          .getElementById('choose-element')
          .classList.remove('selected-active')
      }

      this.$refs['my-modal'].hide()
    },
    async initCheckboxes () {
      // In case we are editing an invitation
      if (this.editId) {
        const res = await axios({
          url: ENTRYPOINT + '/api/invitation/edit/' + this.editId,
          method: 'GET'
        })

        this.initialTableau = res.data.data.tableau
        this.initialSchema = res.data.data.schemas
        this.initialFiche = res.data.data.fiches.view
        this.initialFicheEdit = res.data.data.fiches.edit

        this.tableauSurface = res.data.data.tableau

        if (
          res.data.data.fiches instanceof Array &&
          res.data.data.fiches.length > 0
        ) {
          this.ficheEspacesModel = res.data.data.fiches.view
          this.ficheEspacesEditModel = res.data.data.fiches.edit
        } else if (
          typeof res.data.data.fiches === 'object' &&
          !(res.data.data.fiches instanceof Array)
        ) {
          this.ficheEspacesModel = res.data.data.fiches.view
          this.ficheEspacesEditModel = res.data.data.fiches.edit
        }
        this.schema = res.data.data.schemas
      }

      var fiches = this.listModuleInModal['fiche_espace']

      for (
        var i = 0;
        i < this.listModuleInModal['tableau_surface'].length;
        i++
      ) {
        var tableauId = this.listModuleInModal['tableau_surface'][i].id

        if (fiches[tableauId]) {
          if (typeof this.ficheEspaces[tableauId] === 'undefined') {
            this.ficheEspaces[tableauId] = []

            if (typeof this.ficheEspacesModel[tableauId] === 'undefined') {
              this.ficheEspacesModel[tableauId] = []
            }

            if (typeof this.ficheEspacesEditModel[tableauId] === 'undefined') {
              this.ficheEspacesEditModel[tableauId] = []
            }

            this.finalFicheArray[tableauId] = []
          }

          if (typeof this.allFieldSelected[tableauId] === 'undefined') {
            this.allFieldSelected[tableauId] = []
          }

          if (typeof this.allFieldEditSelected[tableauId] === 'undefined') {
            this.allFieldEditSelected[tableauId] = []
          }
        }
      }
    },
    /**
     *
     * @param table      The id of the selected TableauSurface
     * @param listModule The column (fiche_espace, schema)
     */
    checkAll (table, listModule, type, isChecked) {
      this.isAllFicheViewChecked[table] = !this.isAllFicheViewChecked[table]
      this.ficheEspaces[table] = this.ficheEspaces[table] || []

      if (isChecked === false) {
        this.ficheEspaces[table] = []
        this.ficheEspacesModel[table] = []
        this.allFieldSelected[table] = []
        this.ficheEspacesModel[table] = []
      }

      if (isChecked) {
        this.hasEdits = true
      } else {
        this.hasEdits = false
      }

      var checkboxes = document.getElementsByClassName('viewAll_' + table)

      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = isChecked

        if (isChecked) {
          var v = Object.values(checkboxes[i])
          this.ficheEspaces[table].push(v[1])
          this.allFieldSelected[table].push(v[1])
          this.ficheEspacesModel[table].push(v[1])
        }
      }
    },
    checkAllEdit (table, listModule, type, isChecked) {
      if (isChecked) {
        this.hasEdits = true
      } else {
        this.hasEdits = false
      }

      this.isAllFicheEditChecked[table] = !this.isAllFicheEditChecked[table]

      this.ficheEspaces[table] = this.ficheEspaces[table] || []
      this.allFieldEditSelected[table] = []
      this.ficheEspacesEditModel[table] = []

      if (isChecked === false) {
        this.ficheEspaces[table] = []
        this.allFieldEditSelected[table] = []
        this.ficheEspacesEditModel[table] = []
      }

      var checkboxes = document.getElementsByClassName('editAll_' + table)

      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = isChecked

        if (isChecked) {
          var v = Object.values(checkboxes[i])
          this.ficheEspaces[table].push(v[1])
          this.allFieldEditSelected[table].push(v[1])
          this.ficheEspacesEditModel[table].push(v[1])
        }
      }
    },
    updateCheckAll (table, isChecked) {
      if (typeof this.ficheEspaces[table] === 'undefined') {
        return
      }

      if (isChecked) {
        this.hasEdits = true
      } else {
        this.hasEdits = false
      }

      if (
        this.ficheEspaces[table].length > 0 &&
        this.ficheEspaces[table].length === this.allFieldSelected[table].length
      ) {
        this.isAllFicheViewChecked[table] = true
        document.getElementById('viewAll_' + table).checked = true
      } else {
        this.isAllFicheViewChecked[table] = false
        document.getElementById('viewAll_' + table).checked = false
      }
    },
    updateCheckAllEdit (table, isChecked) {
      if (typeof this.ficheEspaces[table] === 'undefined') {
        return
      }

      if (isChecked) {
        this.hasEdits = true
      } else {
        this.hasEdits = false
      }

      if (
        this.ficheEspaces[table].length > 0 &&
        this.ficheEspaces[table].length ===
          this.allFieldEditSelected[table].length
      ) {
        this.isAllFicheEditChecked[table] = true
        document.getElementById('editAll_' + table).checked = true
      } else {
        this.isAllFicheEditChecked[table] = false
        document.getElementById('editAll_' + table).checked = false
      }
    },
    handleClickSend () {
      const payload = {
        email: this.email,
        nom: this.name,
        message: this.message,
        choices: this.choices,
        idProjet: parseInt(this.$route.params.idProject, 10),
        type: {
          [this.typeModule]: this.noChoice
            ? this.selectedEntityId
            : [parseInt(this.$route.params.idProject, 10)]
        }
      }
      this.$emit('onClickSend', payload)

      this.tableauSurface = []
      this.ficheEspaces = []
      this.ficheEspacesModel = []
      this.ficheEspacesEditModel = []
      this.schema = []
      this.hasSelectedElements = false

      if (document.getElementById('choose-element')) {
        document
          .getElementById('choose-element')
          .classList.remove('selected-active')
      }
    },
    showDeleteConfirmation (id) {
      this.$bvModal
        .msgBoxConfirm(`Voulez-vous vraiment supprimer ?`, {
          modalClass: 'base-modal',
          title: "Suppression d' invitation",
          buttonSize: 'sm',
          headerClass: 'bg-danger',
          okVariant: 'outline-danger',
          okTitle: 'OUI',
          cancelVariant: 'outline-primary',
          cancelTitle: 'NON',
          footerClass: 'p-2',
          hideHeaderClose: true
        })
        .then(async (value) => {
          if (value) {
            this.$emit('onDeleteConfirm', id)
          }
        })
    },
    handleDeleteInvitation (id) {
      this.showDeleteConfirmation(id)
    },
    async openEditModal (id) {
      this.editId = id

      this.$refs['my-modal'].show()
    },
    resetModal () {
      this.editId = null
      this.hasEdits = false
      this.notifyUser = false
    },
    checkNoChoice () {
      if (
        this.$route.name !== 'cahier_environnemental' &&
        this.$route.name !== 'specification_technique'
      ) {
        this.noChoice = true
        return
      }
      this.noChoice = false
    },
    async updateInvitation () {
      this.isLoading = true
      for (var key in this.ficheEspacesModel) {
        for (var i = 0; i < this.ficheEspacesModel[key].length; i++) {
          this.finalFicheArray[key].push(this.ficheEspacesModel[key][i])
        }
      }

      for (var index in this.ficheEspacesEditModel) {
        for (var j = 0; j < this.ficheEspacesEditModel[index].length; j++) {
          this.finalFicheArray[index].push(
            this.ficheEspacesEditModel[index][j]
          )
        }
      }

      this.choices = {
        tableauSurface: this.tableauSurface,
        ficheEspaces: this.finalFicheArray,
        schema: this.schema
      }

      const payload = {
        email: this.email,
        nom: this.name,
        message: this.message,
        notifyUser: this.notifyUser,
        choices: this.choices,
        invitationGroupId: this.editId,
        idProjet: parseInt(this.$route.params.idProject, 10),
        type: {
          [this.typeModule]: this.noChoice
            ? this.selectedEntityId
            : [parseInt(this.$route.params.idProject, 10)]
        }
      }

      const resp = await axios({
        url: ENTRYPOINT + '/api/invitation/update',
        data: payload,
        method: 'POST'
      })

      this.$emit('onUpdated')
      this.$refs['my-modal'].hide()
      this.isLoading = false

      this.tableauSurface = []
      this.ficheEspaces = []
      this.ficheEspacesModel = []
      this.ficheEspacesEditModel = []
      this.schema = []
    }
  }
}
</script>

<style lang="scss" scoped>
.titre-tableau {
  height: 25px;
  line-height: 25px;
  color: #fff;
  background-color: #2b3085;
  font-size: 12px;
  margin-bottom: 15px;
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
}
.liste-espace {
  padding-left: 15px;
  font-size: 12px;
  margin-bottom: 15px;
}

.wrapper-padding {
  padding-top: 0px;
  padding-bottom: 50px;
  padding-left: 30px;
  padding-right: 30px;
  .btn-primary {
    margin-bottom: 0;
    border: 1px solid #2b3085;
    color: #2b3085;
    font-size: 14px;
    border-radius: 0;
    background-color: #fff;
    height: 25px;
    line-height: 25px;
  }
  input {
    border: 1px solid #2b3085;
    font-size: 15px;
    line-height: 30px;
    height: 30px;
    color: #2b3085;
    font-family: "Noto Sans", sans-serif;
    padding: 0 5px;
    margin-bottom: 15px;
  }

  textarea {
    border: 1px solid #2b3085;
    font-size: 15px;
    line-height: 30px;
    color: #2b3085;
    font-family: "Noto Sans", sans-serif;
    padding: 0 5px;
    margin-bottom: 15px;
  }
}

.listing-box,
.listing-shared-element {
  .scroll-area {
    height: calc(90vh - 350px);
    margin-right: -15px;
    padding-right: 15px;
  }
}

#select-module-modal {
  .modal-dialog {
    top: 100px;
  }
}

.table-col-header {
  background: #9395c1;
  color: #fff;
  border-radius: 3px;
  padding: 3px 0;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
}

.checkbox-group {
  margin: 0 17px;
  border-top: 2px solid rgba(0, 0, 0, 0.05);
  padding-top: 11px;
}

.icon-example-border {
  border-color: #e9e9e9;
  padding: 2px 5px;
}

.scroll-area {
  margin-top: 25px;
}

.label-size {
  font-size: 14px;
}

.table-name h6 {
  text-align: center;
  background: #2b3085;
  color: #fff;
  padding: 5px 0;
}

.selected-active {
  color: #fff !important;
  background-color: #1f225e !important;
  border-color: #1b1f55 !important;
}

/*.my-custom-label {*/
/*  display: block;*/
/*  border: 4px solid #88a;*/
/*  box-shadow: 1px 1px 3px rgba(0, 0, 0, .3) inset;*/
/*  border-radius: 10%;*/
/*  width: 1em;*/
/*  height: 1em;*/
/*}*/
/*input[type="checkbox"] {*/
/*  display: none;*/
/*}*/
/*input[type="checkbox"]:checked + label {*/
/*  background-color: rgba(0, 255, 0, .8);*/
/*  box-shadow: 0px 0px 2px rgba(0, 0, 0, .1) inset;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/voletLaterale/accesEnVue/index.vue